import React, {useEffect} from "react";
import {Switch, Route} from "react-router-dom";


import Chat from "./Chat/Chat";
import Profile from "./Profile/Profile"
import Campaign from "./Campaign/Campaign"
import Sidebar from './Sidebar/Sidebar.js';
import classes from "./Home.module.css";

import RoominvitationService from "../../services/RoominvitationService"
import {useDispatch, useSelector} from "react-redux";

import { selectInviteChannelId, unsetRoominvitation} from "../../store/reducers/roominvitationSlice"
import { selectUser } from "../../store/reducers/userSlice";

export default function Home() {

  const dispatch = useDispatch();
  // const inviteChannelId = useSelector(selectInviteChannelId())
  const inviteChannelId = useSelector(selectInviteChannelId);
  const user = useSelector(selectUser)
  dispatch(unsetRoominvitation)

  useEffect(() => {
    if (inviteChannelId !== null && user) {
      (new RoominvitationService()).addUserToRoomById(user, inviteChannelId);
    }
  });

  return (
    <Switch>
      <>
        <div className={classes.Home}>
          <Sidebar/>
          <Route path="/" exact component={Chat}/>
          <Route path="/profile" exact component={Profile}/>
          <Route path="/campaign" exact component={Campaign}/>

        </div>
      </>
    </Switch>

  );
}


